export const ACCOUNT_GENERAL_PHRASES = {
    ACCOUNT_TITLE: 2747,
    USER_ID: 1760,
    SAVE_BUTTON: 15973,
    TYPE_CODE: 15974,
    PLEASE_REFERR_USER_ID: 17185,
    COPIED: 17437,
} as const;

export const ACCOUNT_MENU_PHRASES = {
    PERSONAL_DETAILS: 10412,
    PROFESSIONAL_DETAILS: 10413,
    ADDITIONAL_DETAILS: 14251,
    CONTACT_DETAILS: 10414,
    CHANGE_PASSWORD: 15975,
    TAX_DETAILS: 17466,
    EMAIL_PREFERENCES: 18173,
    CONTACT_PREFERENCES: 19297,
    AUTHENTICATOR_APP: 19129,
    PAYOUT_DETAILS: 19687,
} as const;

export const ACCOUNT_PERSONAL_DETAILS_PHRASES = {
    NOTIFICATION_MESSAGE: 3755,
    NOTIFICATION_MESSAGE_SUPPORT_VAR: 2905,
    FIRST_NAME: 36,
    FIRST_NAME_REQUIRED_ERROR: 347,
    FIRST_NAME_INVALID_ERROR: 714,
    LAST_NAME: 37,
    LAST_NAME_REQUIRED_ERROR: 348,
    LAST_NAME_INVALID_ERROR: 715,
    COUNTRY: 44,
    COUNTRY_REQUIRED_ERROR: 350,
    ZIP: 45,
    ZIP_REQUIRED_ERROR: 326,
    CITY: 46,
    CITY_REQUIRED_ERROR: 340,
    STATE_CODE: 566,
    STATE_CODE_REQUIRED_ERROR: 10896,
    ADDRESS1: 336,
    ADDRESS1_REQUIRED_ERROR: 337,
    ADDRESS2: 338,
    TIMEZONE: 1808,
    PREFERRED_LANGUAGE: 3261,
    PREFERRED_LANGUAGE_REQUIRED_ERROR: 3262,
    MARKET_RESEARCH: 10411,
    MARKET_RESEARCH_OPT_IN: 19281,
    MARKET_RESEARCH_REQUIRED_ERROR: 10611,

    USA_RESTRICTION_WARNING: 15978,
    ADDRESS_HEADER: 15976,
    SETTINGS_HEADER: 15977,

    // dev phrases (don't have tagIds)

    HOW_HEARD_INSTAGRAM: 13229, // dev only
    COUNTRY_CANADA: 90000500, // dev only
    COUNTRY_UK: 90000501, // dev only
    PROFESSION_NURSING: 90000038, // dev only
    PREFFERED_LANG_EN: 2129, // dev only
    PREFFERED_LANG_FR: 2131, // dev only
} as const;

export const ACCOUNT_PROFESSIONAL_DETAILS_PHRASES = {
    PROFESSION: 47,
    PROFESSION_REQUIRED_ERROR: 356,
    WHAT_MEDICAL_SCHOOL: 332,
    YEAR_OF_GRADUATE: 333,
    SELECT_SPECIALTY: 330,
    SPECIALTY_REQUIRED_ERROR: 15979,
    GRADUATION_YEAR_REQUIRED_ERROR: 15980,
    MEDICAL_SCHOOL_REQUIRED_ERROR: 15981,
    PRIMARY_WORKPLACE_NAME: 14261,
    WORKPLACE_MAINLINE_NUMBER: 14263,
} as const;

export const ACCOUNT_PASSWORD_CHANGE_PHRASES = {
    CURRENT_PASSWORD_REQUIRED_ERROR: 362,
    NEW_PASSWORD: 2827,
    NEW_PASSWORD_REQUIRED_ERROR: 362,
    NEW_PASSWORD_INVALID_ERROR: 3677,
    PASSWORD_UPDATED_TEXT: 2824,
    NEW_PASSWORD_CONFIRM_INVALID_ERROR: 3677,
    NEW_PASSWORD_CONFIRM_REQUIRED_ERROR: 362,
    NEW_PASSWORD_DONT_MATCH_ERROR: 363,
    NEW_PASSWORD_CONFIRM_DONT_MATCH_ERROR: 363,
    CURRENT_PASSWORD: 15982,
    NEW_PASSWORD_CONFIRM: 15983,
    NEW_PASSWORD_NOT_EQUAL_CURRENT_ERROR: 15984,
    NEW_PASSWORD_CONFIRM_NOT_EQUAL_CURRENT_ERROR: 15984,
    PASS_REQUIREMENTS_TITLE: 15949,
    PASS_REQUIREMENTS_LIST: 15985,
} as const;

export const ACCOUNT_PHRASES = {
    SAVE: 15973,
} as const;

export const ACCOUNT_CONTACT_DETAILS_PHRASES = {
    EMAIL: 13231,
    MOBILE_PHONE: 567,
    ALTERNATIVE_PHONE: 2217,
    SMS_OPT_IN: 2198,
    VERIFICATION_IN_PROGRESS: 2774,
    PLEASE_CONFIRM_EMAIL: 17210,
    PLEASE_CONFIRM_PHONE: 3778,
    EMAIL_ADDRESS: 168,
    ALTERNATIVE_PHONE_1: 15986,
    ALTERNATIVE_PHONE_2: 15987,
    PRIMARY: 15988,
    CONFIRMED: 15989,
    PHONE_NUMBERS: 15990,
    USED_FOR_LOGIN: 15991,
    EMAIL_VERIFICATION_COMPLETE: 15992,
    EMAIL_VERIFICATION_FAILED: 15993,
    FAULTY_EMAIL_VERIFICATION_LINK: 15994,
    INVALID_MOBILE_PHONE_NUMBER: 3771,
    OTC_SENT: 15997,
    RESEND_CONFIRMATION_CODE: 17238,
} as const;

export const ACCOUNT_TAX_DETAILS_PHRASES = {
    SSN: 17654,
    ITIN: 17655,
    EIN: 17656,
    TAX_PAYER_ID: 17657,
    FULL_NAME: 17624,
    LAST_NAME: 37,
    ADDRESS: 336,
    CITY: 46,
    STATE: 566,
    ZIP: 45,
    TAX_PAYER_ID_NUM: 17667,
    BY_SUBMITTING_THIS_FORM: 17677,
    ENTER_TAX_PAYER_ID: 17668,
    PREFER_AN_ALTERNATE_WAY: 17661,
    SUBMITTING_VIA_WEB_FORM: 17675,
    SUBMITING_VIA_FAX: 17662,
    FAX_PLEASE_DOWNLOAD: 17665,
    SUBMITING_VIA_MAIL: 17663,
    MAIL_PLEASE_DOWNLOAD: 17666,
    REQUEST_TAX_PAYER_ID: 17664,
    THANK_YOU_FOR_YOUR_PARTICIPATION: 17658,
    THANK_YOU_FOR_SUBMITTING: 17669,
    YOUR_CURRENT_TIN: 17676,
    ACTION_NEEDED: 17708,
    M3_REQUIRES_CONFIRMATION: 17709,
    SELECT_ONE: 17923,
} as const;

export const ACCOUNT_NOTIFICATIONS_PHRASES = {
    SNOOZE: 18399,
    CLOSE: 3467,
} as const;

export const ACCOUNT_AUTHENTICATOR_APP_PHRASES = {
    AUTHENTICATOR_APP: 18932,
    USE_AUTHENTICATOR_APP: 18956,
    DISABLE_NOTE: 19106,
    HOW_IT_WORKS: 805,
    SELECT_AND_DOWNLOAD_APP_STEP: 19109,
    CREATE_ACCOUNT_IN_THE_APP_STEP: 19110,
    RECEIVE_OTP_CODE_STEP: 19111,
    ENTER_THE_CODE_AND_SUBMIT_STEP: 19112,
    WHICH_APP_TO_USE: 18949,
    SELECT_AND_DOWNLOAD_APP_TITLE: 19108,
    LIST_OF_APPS_DESCRIPTION: 18951,
    GOOGLE_AUTHENTICATOR: 18952,
    MICROSOFT_AUTHENTICATOR: 18953,
    TWOFAS: 18954,
    TWOFAS_NOTE: 18955,
    SELECT: 18957,
    DESELECT: 18958,
    WAS_SET_UP_TITLE: 18959,
    WAS_SET_UP_TEXT: 18960,
    THANK_YOU: 18961,
    DO_YOU_WANT_TO_REMOVE_OTP: 18962,
    YES_PLEASE: 18963,
    CANCEL: 189,
    SUBMIT: 1972,
    SETUP_YOUR_AUTH_APP_TITLE: 19107,
    YOUR_CODE: 18964,
    VERIFY_CODE: 18965,
    VERIFICATION_TEXT: 18966,
    SCAN_QR_CODE: 18967,
    QR_CODE_MAIN_TEXT: 18968,
    QR_CODE_INFO_TEXT: 18969,
    ACCOUNT_NAME: 18970,
    SECRET_KEY: 18971,
    BACK: 3477,
} as const;

export const ACCOUNT_INVOICING_PHRASES = {
    BUSINESS_TAX_DETAILS_INTRO: 19688,
    REGISTER_FOR_INVOICING: 19689,
    BUSINESS_NAME: 19690,
    VAT_REGISTERED: 19738,
    VAT_REGISTERED_INSTRUCTION: 19693,
    VAT_NUMBER: 19691,
    ADDRESS: 20593,
    ADDRESS2: 338,
    CITY: 46,
    STATE: 566,
    ZIP: 45,
    COUNTRY_CODE: 44,
    MORE_DETAILS_ABOUT_VAT: 19731,
    DO_YOU_WANT_VAT_ADDED: 19730,
    ELECTRONIC_INVOICES: 19729,
    YES: 20281,
    NO: 20282,
    PERSONAL_TAX_ID: 20396,
    INVOICE_DETAILS_AND_VAT_PREFERENCES: 20595,
    VAT_DETAILS: 20594,
} as const;

export const ACCOUNT_INDIA_PAYOUT_PHRASES = {
    REQUIRED_TO_COLLECT_PAN: 21533,
    PAN_PHRASE: 21443,
    AADHAAR_PHRASE: 21444,
    CHANGE_CONTACT_DETAILS: 21534,
} as const;
